import { styled } from '@styledComponents';
import { Flex } from '@components/Flex';
import { Box } from '@components/Box';
import { TextPairing } from '@components/TextPairing';
import { CloudImage } from '@components/CloudImage';
import { themeMediaQuery } from '@utils/styledTheme.util';
import { Columns } from '@components/Columns';

export const StyledSection = styled(Box)`
  position: relative;
`;

export const JoyButtonTextPairing = styled(TextPairing)`
  .text-pairing-title {
    max-width: 320px;
  }
  .text-pairing-body {
    max-width: 300px;
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title {
      max-width: 100%;
    }
    .text-pairing-body {
      max-width: 100%;
    }
  }
`;

export const StyledBrandImage = styled(CloudImage)<{ bkgPosition?: string }>`
  max-width: 180px;
  max-height: 220px;
  object-fit: contain;
  object-position: ${({ bkgPosition }) => bkgPosition || '0px 55px'};
`;

export const StyledBrandName = styled(CloudImage)<{ width?: number; height?: number; bkgPosition?: string }>`
  max-width: ${({ width }) => width || 180}px;
  max-height: ${({ height }) => height || 20}px;
  object-fit: contain;
  margin-top: 20px;
  object-position: ${({ bkgPosition }) => bkgPosition || '0px 0px'};
`;

export const BrandsWrapper = styled(Box)`
  position: relative;
  width: max-content;
`;

export const BrandImageWrapperBox = styled(Flex)`
  width: 100%;
`;

export const BrandImageBox = styled(Flex)``;

export const StyledColumn = styled(Columns)`
  ${themeMediaQuery('sm')} {
    max-width: 55rem;
  }
  ${themeMediaQuery('md')} {
    max-width: 90rem;
  }
`;
